export default "__VITE_ASSET__BTPygRMW__"